/**
 * Pipe que insere uma sitação num texto.
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'format3'
})
export class Format3Pipe implements PipeTransform {

  transform(value: any, ...args: any[]) {
    value += '\n';
    // Expressão regular para encontrar tags <blockquote>
    const blockquoteRegex = /<blockquote([^>]*)>(.*?)<\/blockquote>/gi;
    // Substituir por <blockquote class='blockquote'>
    return value.replace(blockquoteRegex, (match: any, p1: string, p2: any) => {
      // Se a tag tiver a classe 'blockquote', não altera.
      if (/class=['|"]\bblockquote\b['|"]/.test(p1)) {
        return match;
      }
      // Caso contrário, adiciona a classe 'blockquote'
      return `<blockquote class='blockquote'${p1}>${p2}</blockquote>`;
    });
  }

}
